import { Injectable } from '@angular/core';
import { PagedTableResponse } from '../../models/common/paged-table.model';
import {
  AdminActivityLog,
  AdminActivityLogChange,
  AdminActivityLogChangeDto,
  AdminActivityLogDto,
} from '../../models/system-settings/admin-activity-log.model';

@Injectable({ providedIn: 'root' })
export class MapperAdminActivityLogService {
  mapRow(dto: AdminActivityLogDto): AdminActivityLog {
    const raw = dto as AdminActivityLogDto & Record<string, unknown>;
    const changesRaw = (dto.changes ?? dto.Changes ?? raw['Changes'] ?? []) as AdminActivityLogChangeDto[];

    return {
      id: Number(dto.id ?? dto.Id ?? raw['Id'] ?? 0),
      actorUserId: Number(dto.actorUserId ?? dto.ActorUserId ?? raw['ActorUserId'] ?? 0),
      actorUsername: String(dto.actorUsername ?? dto.ActorUsername ?? raw['ActorUsername'] ?? ''),
      action: String(dto.action ?? dto.Action ?? raw['Action'] ?? ''),
      entityType: String(dto.entityType ?? dto.EntityType ?? raw['EntityType'] ?? ''),
      entityId: Number(dto.entityId ?? dto.EntityId ?? raw['EntityId'] ?? 0),
      menuId: (dto.menuId ?? dto.MenuId ?? raw['MenuId'] ?? null) as number | null,
      summaryTh: String(dto.summaryTh ?? dto.SummaryTh ?? raw['SummaryTh'] ?? ''),
      changes: (Array.isArray(changesRaw) ? changesRaw : []).map((c: AdminActivityLogChangeDto) =>
        this.mapChange(c)
      ),
      requestPath: String(dto.requestPath ?? dto.RequestPath ?? raw['RequestPath'] ?? ''),
      ipAddress: String(dto.ipAddress ?? dto.IpAddress ?? raw['IpAddress'] ?? ''),
      createDate: (dto.createDate ?? dto.CreateDate ?? raw['CreateDate'] ?? null) as string | null,
    };
  }

  mapChange(dto: AdminActivityLogChangeDto): AdminActivityLogChange {
    const raw = dto as AdminActivityLogChangeDto & Record<string, unknown>;
    return {
      field: String(dto.field ?? dto.Field ?? raw['Field'] ?? ''),
      before: (dto.before ?? dto.Before ?? raw['Before'] ?? null) as string | null,
      after: (dto.after ?? dto.After ?? raw['After'] ?? null) as string | null,
    };
  }

  mapTable(res: unknown): PagedTableResponse<AdminActivityLog> {
    const raw = (res ?? {}) as Record<string, unknown>;
    const dataRaw = (raw['data'] ?? raw['Data'] ?? []) as AdminActivityLogDto[];
    const data = (Array.isArray(dataRaw) ? dataRaw : []).map((item: AdminActivityLogDto) =>
      this.mapRow(item)
    );
    const total = Number(raw['total'] ?? raw['Total'] ?? data.length);
    const page = Number(raw['page'] ?? raw['Page'] ?? 1);
    const pageSize = Number(raw['pageSize'] ?? raw['PageSize'] ?? 20);
    const totalPages = Number(raw['totalPages'] ?? raw['TotalPages'] ?? Math.max(1, Math.ceil(total / pageSize)));
    return { data, total, page, pageSize, totalPages };
  }
}
